/**
 * Параметры аналогичны странице:
 * https://www.mamba.ru/ru/landing/russia-3159
 *
 * https://youtrack.mamba.ru/issue/M-8423
 */
export const seriousRelationshipParams = {
  // locale: 'ru',
  country: 'russia',
  countryId: '3159',
  gender: undefined,
}
